import React, { Component } from "react";
import BaseBudgetInfoModal from "./BaseBudgetInfoModal";

export default class ChangeInfoModal extends Component {

	render() {
		return (
			<BaseBudgetInfoModal title="Solicitar orçamento para remarcar seu voo" typeCancel="change" {...this.props}>
				Você iniciou a solicitação para remarcação da sua viagem e, assim que validarmos a possibilidade com a companhia aérea, vamos elaborar
				seu orçamento. Antes da gente prosseguir, selecione abaixo quais passageiros e
				trechos você deseja cancelar.
			</BaseBudgetInfoModal>
		);
	}
}
